import React, {Component} from 'react';
import {
    AJAX,
    showPreloader,
    hidePreloader,
    close_popup,
    compressImage,
    get_phone_id,
    setEmailForMessages,
    setUrlSinglePageApp
} from "../functions";
import {showProgressBarPopup} from "../popups/ProgressBarPopup";
import Popup from "../popups/Popup";
import ProfileFields from "../common/ProfileFields";
import LoginPopup from "../popups/LoginPopup";
import AuthCodePopup from "../popups/AuthCodePopup";
import Avatar from "../common/Avatar";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {withRouter} from "react-router";

class ProfilePage extends Component {
    constructor(props) {
        super(props);

        this.handleUserInput = this.handleUserInput.bind(this);
        this.saveProfile = this.saveProfile.bind(this);
        this.openLoginPopup = this.openLoginPopup.bind(this);
        this.handleActionAfterSuccAuth = this.handleActionAfterSuccAuth.bind(this);
        this.state = {
            showLoginPopup: false,
            showAuthCodePopup: false,
            saveInLocalStorage: true,
            already_auth: (window.gClientData.email ? true : false),
            uploadPercent: 0,
            client_data: {},
            errorInputs:{},
            email_exists: false,
            showEmaiExistsPopup: false,
            showPinCodePopupIfAlreadyAuth: false,
            avatarTimestamp: 0
        };
        this.props.client_data_fields.forEach(el => {
            if(!this.state.client_data[el])
                this.state.client_data[el] = ''
        });

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    componentDidMount() {
        this.getProfile();
    }

    handleActionAfterSuccAuth() {
        if (this.state.email_exists) {
            this.saveProfile();
        } else {
            this.getProfile(true);
            let avatarTimestamp = Date.now();
            this.setState({avatarTimestamp});
            if (typeof window.updateAvatarInMenu === 'function') {
                window.updateAvatarInMenu(avatarTimestamp);
            }
        }
    }

    getProfile(updateLocalStorage = false) {
        let t = this;

        let params = {
            action: 'api/booking/get_profile'
        };
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    t.setState({client_data: resp.data.client_data, already_auth: true, errorInputs: {}});
                    if (updateLocalStorage)
                        setEmailForMessages(t.state.client_data.email);
                    window.gClientData = resp.data.client_data;
                    get_phone_id();
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    handleUserInput(e) {
        let name = e.target.name;
        let value = e.target.value;

        if (this.props.client_data_fields.indexOf(name) !== -1) {
            let cd = this.state.client_data;
            cd[name] = value;
            this.setState({client_data: cd});
        }
    }

    saveProfile() {
        let t = this;
        let params = {...this.state.client_data};
        params.action = 'api/booking/save_profile';

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length && resp.data.profile_data) {
                    t.setState({client_data: resp.data.profile_data, already_auth:true});
                    setEmailForMessages(t.state.client_data.email);
                    window.gClientData = resp.data.profile_data;
                    showPopupWithGoBack('Your Profile Has Been Saved');
                    t.setState({errorInputs: {}});
                    get_phone_id();
                } else if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                    showPopupWithGoBack(resp.errors.main);
                }

                if (resp.errors !== undefined && resp.errors.form !== undefined) {
                    t.setState({errorInputs: resp.errors.form});
                }

                if (resp.errors !== undefined && resp.errors.email_exists) {
                    t.setState({email_exists: true});
                    if (t.state.already_auth)
                        t.setState({showPinCodePopupIfAlreadyAuth: true});
                    else
                        t.setState({showEmaiExistsPopup: true});
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    sendAvatar(e) {
        let t = this;
        let file = e.target.files[0];
        if (!file)
            return false;

        compressImage(
            file,
            (modifiedFile) => {
                let params = {
                    files: {
                        photo: modifiedFile
                    },
                    action: 'api/booking/send_avatar'
                };

                AJAX(bm_ajax_url, 'POST', params, {
                    response_json: true,
                    func_waiting: ()=>showProgressBarPopup(t.state.uploadPercent),
                    func_callback: function (resp) {
                        close_popup();
                        if (resp.success === 1) {
                            let avatarTimestamp = Date.now();
                            t.setState({uploadPercent: 0, avatarTimestamp: avatarTimestamp});
                            if (typeof window.updateAvatarInMenu === 'function')
                                window.updateAvatarInMenu(avatarTimestamp);
                        } else {
                            if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                                showPopupWithGoBack(resp.errors.main);
                            }
                        }
                    },
                    func_error: function (resp) {
                        close_popup();
                        showPopupWithGoBack(resp.message);
                    },
                    func_progress: function (evt) {
                        if (evt.lengthComputable) {
                            let percentComplete = Math.round(evt.loaded / evt.total * 100);
                            t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));

                        }
                    }
                });
            }
        )
    }

    openLoginPopup(e) {
        e.preventDefault();
        this.setState({showLoginPopup: true});
    }

    render() {
        return (
            <div className={'value-space'}>
                {
                    !this.state.already_auth ? (
                        <div className="row">
                            <div className="offset-2 col-8 my-4 text-center">
                                <p>Already have an account?<br/>Click <a className="blue-link" onClick={this.openLoginPopup}>here</a></p>
                            </div>
                        </div>
                    ) : (<>
                            <div className="row">
                                <div className="col-12 text-center">
                                    <Avatar  timestamp={this.state.avatarTimestamp}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="offset-2 col-8 my-3">
                                    <div className="form-group text-center">
                                        <input type="file" id="avatar" accept="image/*" capture="camera"
                                               className="form-control mb-4" name="photo"
                                               onChange={this.sendAvatar.bind(this)}
                                        />
                                        <label htmlFor="avatar"
                                               className="base-input">TAKE AVATAR</label>

                                        <input type="file" id="avatar_upload" accept="image/*"
                                               className="form-control mb-4" name="photo"
                                               onChange={this.sendAvatar.bind(this)}
                                        />
                                        <label htmlFor="avatar_upload"
                                               className="base-input">UPLOAD AVATAR</label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }

                <div className="row">
                    <div className="offset-2 col-8 text-center form-inputs">
                        {/*<h2>Mobile Number</h2>
                        <div className="form-group mb-4">
                            <input type="text" className="form-control base-input" name="mobile"
                                   placeholder="Mobile Number" onChange={this.handleUserInput}
                                   defaultValue={this.state.client_data.mobile}/>
                                   <div id="mobile_errors" />
                        </div>
                        <h2>First Name</h2>
                        <div className="form-group mb-4">
                            <input type="text" className="form-control base-input" name="first_name"
                                   placeholder="First Name" onChange={this.handleUserInput}
                                   defaultValue={this.state.client_data.first_name}/>
                                   <div id="first_name_errors" />
                        </div>
                        <h2>Last Name</h2>
                        <div className="form-group mb-4">
                            <input type="text" className="form-control base-input" name="last_name"
                                   placeholder="Last Name" onChange={this.handleUserInput}
                                   defaultValue={this.state.client_data.last_name}/>
                                   <div id="last_name_errors" />
                        </div>
                        <h2>Date of Birth</h2>
                        <div className="form-group mb-4">
                            <input type="date" className="form-control base-input" name="dob"
                                   placeholder="Date Of Birth" onChange={this.handleUserInput}
                                   defaultValue={this.state.client_data.dob}/>
                                   <div id="dob_errors" />
                        </div>
                        <h2>Driver License Number</h2>
                        <div className="form-group">
                            <input type="text" className="form-control base-input" name="driver_license"
                                   placeholder="Driver License Number" onChange={this.handleUserInput}
                                   defaultValue={this.state.client_data.driver_license}/>
                                   <div id="driver_license_errors" />
                        </div>*/}
                        {/*<Input label={'Mobile Number'}
                               placeholder={'Mobile Number'}
                               name={'mobile'}
                               value={this.state.client_data.mobile}
                               hanldeChange={this.handleUserInput}
                               error={this.state.errorInputs.mobile}
                        />
                        <Input label={'First Name'}
                               placeholder={'First Name'}
                               name={'first_name'}
                               value={this.state.client_data.first_name}
                               hanldeChange={this.handleUserInput}
                               error={this.state.errorInputs.first_name}
                        />
                        <Input label={'Last Name'}
                               placeholder={'Last Name'}
                               name={'last_name'}
                               value={this.state.client_data.last_name}
                               hanldeChange={this.handleUserInput}
                               error={this.state.errorInputs.last_name}
                        />
                        <Input label={'Date of Birth'}
                               placeholder={'Date of Birth'}
                               name={'dob'}
                               value={this.state.client_data.dob}
                               hanldeChange={this.handleUserInput}
                               error={this.state.errorInputs.dob}
                               type={'date'}
                        />
                        <Input label={'Driver License Number'}
                               placeholder={'Driver License Number'}
                               name={'driver_license'}
                               value={this.state.client_data.driver_license}
                               hanldeChange={this.handleUserInput}
                               error={this.state.errorInputs.driver_license}
                        />*/}
                        <ProfileFields client_data={this.state.client_data}
                                       errors={this.state.errorInputs}
                                       handleUserInput={this.handleUserInput}
                        />
                        <div className="d-flex justify-content-center align-items-center mt-4">
                            <div className="go-btn go-submit" onClick={this.saveProfile}/>
                        </div>
                    </div>
                </div>
                <LoginPopup show={this.state.showLoginPopup}
                            handleClose={()=>this.setState({showLoginPopup: false})}
                            handleActionAfterSuccAuth={this.handleActionAfterSuccAuth}
                />
                <Popup open={this.state.showEmaiExistsPopup}
                       modal
                       lockScroll
                       closeOnDocumentClick={false}
                       className={"bm-modal"}
                >
                    <>
                        <button type="button" className="close" aria-label="Close" onClick={()=>this.setState({showEmaiExistsPopup: false})}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="clearfix" />
                        <div className="col-12 text-center form-inputs">
                           <p>This email already exists, try to login</p>
                        </div>
                    </>
                </Popup>
                <AuthCodePopup showPopup={this.state.showPinCodePopupIfAlreadyAuth}
                               email={this.state.client_data.email}
                               handleClosePopup={()=>this.setState({showPinCodePopupIfAlreadyAuth: false})}
                               handleSuccessfulRequest={this.handleActionAfterSuccAuth}
                               already_auth
                />
            </div>
        );
    }
}

const ProfilePageR = withRouter(ProfilePage);
export default ProfilePageR;